export { default as HiddenOnPlatform } from './hiddenOnPlatform.component';
